/**
 * @Author: WeiZisen
 * @Date: 2020-12-23 15:40:49
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-05-11 09:19:46
 * @Description: 过滤key value 数字 对应 文本值
 * @FilePath: \Vue_RebarProcess\src\utils\filter.js
 */

/**
 * @description: BimTable组件过滤按钮数组
 * @param ['add', 'edit', 'delete', 'export']
 * @return [{name:"新增",type:"success",icon:"el-icon-plus"}]
 */
export function btnFilter(btnList) {
  let btnArray = []
  for (let i = 0; i < btnList.length; i++) {
    switch (btnList[i]) {
      case 'add':
        btnArray.push({ name: '新增', type: 'success', icon: 'el-icon-plus' })
        break
      case 'edit':
        btnArray.push({ name: '修改', type: 'primary', icon: 'el-icon-edit' })
        break
      case 'check':
        btnArray.push({ name: '查看', type: 'warning', icon: 'el-icon-monitor' })
        break
      case 'delete':
        btnArray.push({ name: '删除', type: 'danger', icon: 'el-icon-delete' })
        break
      case 'connection':
        btnArray.push({ name: '数据关联', type: 'primary', icon: 'el-icon-connection' })
        break
      case 'disconnect':
        btnArray.push({ name: '取消关联', type: 'danger', icon: 'el-icon-paperclip' })
        break
      case 'export':
        btnArray.push({ name: '导出', type: 'warning', icon: 'el-icon-download' })
        break
      case 'continue':
        btnArray.push({ name: '继续流程', type: 'primary', icon: 'el-icon-setting' })
        break
    }
  }
  return btnArray
}
